import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import { ref, PropType, onBeforeMount, computed } from 'vue';
import { IRecurringAskPromptComponent, RecurringAskOption } from '@/builder/interfaces';
import { Frequency, PromptDecision } from "@/builder/enums";
import { useRenderStore } from '@/builder/stores/renderStore';
import { ActionTrigger, ButtonActionType } from '@/builder/components/button/ButtonInterface';
import { amountToNumber, formatCurrency } from '@/builder/utilities';
import { frequencyDisplayName } from '@/enums';
import ButtonComponent from "@/builder/components/button/ButtonComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RecurringAskPrompt',
  props: {
    component: {
        type: Object as PropType<IRecurringAskPromptComponent>,
        required: true
    }
},
  setup(__props) {

const props = __props;

const renderStore = useRenderStore();

//refs
const asks = ref<RecurringAskOption[]>(props.component.customData.asks);
const optOutButton = ref(props.component.customData.optOutButton);
const backgroundColor = ref(renderStore.builderMode ? 'rd-bg-neutral-9' : 'rd-bg-white');

//computed
const askOptions = computed(() => {
    //return only unique options based on text
    return asks.value.filter((ask, index, self) =>
        index === self.findIndex((t) => (
            t.button.customData.text === ask.button.customData.text
        ))
    );
});

//methods
function getAskButtonText(ask: RecurringAskOption) {
    return `Donate $${askAmountCurrency(ask.multiplier)}/${askFrequencyDisplay(ask.frequency)}`;
}

function askAmountCurrency(multiplier: number) {
    return formatCurrency(askAmount(multiplier).toString());
}

function askFrequencyDisplay(frequency: Frequency) {
    return frequencyDisplayName(frequency).toLocaleLowerCase();
}

function askAmount(multiplier: number) {
    const askAmount = amountToNumber(renderStore.gift.amount) * multiplier;

    if (askAmount < 5) {
        return 5; // giving has a minimum of $5
    }
    else {
        return askAmount;
    }
}

function acceptAsk(ask: RecurringAskOption) {
    if (renderStore.gift.amount) {
        let giftAmount = amountToNumber(renderStore.gift.amount);
        giftAmount = askAmount(ask.multiplier);
        renderStore.setAmount(giftAmount.toString());
        renderStore.setFrequency(ask.frequency);
    }

    renderStore.resolvePrompt(props.component.id, PromptDecision.Accept);
}

function declineAsk() {
    renderStore.resolvePrompt(props.component.id, PromptDecision.Decline);
}

function setOptOutButton() {
    if (!optOutButton.value) return;

    optOutButton.value.customData.action = {
        type: ButtonActionType.Custom,
        trigger: ActionTrigger.Click,
        values: declineAsk,
    }
}

function setAskButtons() {
    if (!asks.value) return;
    if (asks.value.length === 0) return;

    asks.value.forEach((ask: RecurringAskOption) => {
        ask.button.customData.text = getAskButtonText(ask);
        ask.button.customData.action = {
            type: ButtonActionType.Custom,
            trigger: ActionTrigger.Click,
            values: () => acceptAsk(ask),
        }
    });
}

//life cycle
onBeforeMount(() => {
    setOptOutButton();
    setAskButtons();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["rd-flex rd-flex-col rd-gap-y-2.5 rd-outline-none recurring-ask-container", [backgroundColor.value, _unref(renderStore).builderMode ? 'rd-mt-6 rd-p-5' : 'rd-mt-12']]),
    "aria-label": "Recurring Gift Ask Buttons",
    tabindex: "0"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(askOptions.value, (ask) => {
      return (_openBlock(), _createBlock(ButtonComponent, {
        key: ask.button.id,
        component: ask.button,
        class: _normalizeClass({ 'rd-pointer-events-none': _unref(renderStore).builderMode })
      }, null, 8, ["component", "class"]))
    }), 128)),
    _createVNode(ButtonComponent, {
      component: __props.component.customData.optOutButton,
      class: _normalizeClass({ 'rd-border rd-border-neutral-6 rd-pointer-events-none': _unref(renderStore).builderMode })
    }, null, 8, ["component", "class"])
  ], 2))
}
}

})